import type { FC } from "react";
import type { RequiredChildrenProp, ThemeName } from "@huub-web/ui";
import {
  ThemeSlotContext,
  type ThemeSlotMap,
} from "@huub-web/ui/contexts/ThemeSlotContext";

import { themeSlotRegistry } from "../../config/themeSlots";

// Stable identity for the "no overrides" fallback — avoids giving context
// consumers a fresh empty object on every render when `theme` is not in the
// registry, which would otherwise trigger needless re-renders.
const EMPTY_SLOTS: ThemeSlotMap = {};

type ThemeSlotProviderProps = RequiredChildrenProp & {
  /**
   * The active theme name used to look up slot overrides
   */
  theme: ThemeName;
};

/**
 * Provides theme-specific component slot overrides to the tree.
 * Reads from the themeSlotRegistry based on the current theme.
 */
export const ThemeSlotProvider: FC<ThemeSlotProviderProps> = ({
  theme,
  children,
}) => {
  const slots = themeSlotRegistry[theme] ?? EMPTY_SLOTS;

  return (
    <ThemeSlotContext.Provider value={slots}>
      {children}
    </ThemeSlotContext.Provider>
  );
};
